import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	unlinkForecastTaskFromTicketMutation,
	UnlinkForecastTaskFromTicketInput,
} from './__generated__/unlinkForecastTaskFromTicketMutation.graphql';

const mutation = graphql`
	mutation unlinkForecastTaskFromTicketMutation($input: UnlinkForecastTaskFromTicketInput!) {
		unlinkForecastTaskFromTicket(input: $input) {
			clientMutationId
			ticket {
				id
				...LinkedTasksTab_ticket
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UnlinkForecastTaskFromTicketInput,
	onCompleted?: (r: unlinkForecastTaskFromTicketMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<unlinkForecastTaskFromTicketMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'unlinkForecastTaskFromTicketMutation'};
